import { useSelector } from 'react-redux'
import { saveSid } from '../../SidCertsHandler'
import getText from '../../../shared/i18n/labels'

// MODAL
import { Modal } from 'react-bootstrap'

// FORM
import { FormPecParameters } from './FormPecParameters'

// COMPONENTS
import { PopupError } from '../../popups/PopupError'

/**
 * Modale per la gestione dei parametri PEC per un soggetto CORA o CRS
 *
 * @param {Object} coraSubjectSid - cora subject SID
 * @param {Boolean} show - flag per la visualizzazione della modale
 * @param {Boolean} archived - flag che dice se un soggetto è archiviato
 * @param {Function} onClose - callback per la chiusura della modale
 * @param {Function} afterSave - callback da chiamare una volta terminato il salvataggio
 *
 */
export function ModalPecParameters({
  coraSubjectSid,
  show = false,
  archived = false,
  onClose = () => {},
  afterSave = (savedSid) => {}
}) {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  /**
   * Salva il soggetto SID passato come argomento chiamando la funzione saveSid.
   * Apre un popup con un messaggio di errore se l'operazione di salvataggio fallisce.
   *
   * @param {Object} subjectSid - Oggetto SID che rappresenta il soggetto da salvare, contenente fiscalCode e application.
   * @param {Function} [afterSave] - Funzione di callback opzionale da chiamare dopo un salvataggio riuscito, con il SID salvato come argomento.
   */
  const save = (subjectSid) => {
    saveSid(
      [],
      subjectSid,
      subjectSid.fiscalCode,
      subjectSid.application,
      (savedSid) => {
        if (afterSave) {
          afterSave(savedSid)
        }
      },
      (errors) => {
        PopupError({
          text: errors.detail ? errors.detail : labels.GENERIC_ERROR
        })
      }
    )
  }

  /**
   * Determina la classe di larghezza da applicare in base alla larghezza interna della finestra.
   *
   * @returns {string} Una stringa contenente la classe di larghezza appropriata.
   *
   */
  const getWidth = () => {
    return window.innerWidth > 1600 ? 'w-55 max-w-55' : 'w-90 max-w-90'
  }

  /**
   * Modale di configurazione dei parametri PEC
   * Contiene il titolo della modale e il form per la configurazione dei parametri PEC
   */
  return (
    <Modal
      backdrop="static"
      show={show}
      onHide={onClose}
      dialogClassName={`${getWidth()} p-2`}
      centered>
      <div className="bar"></div>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h2>{labels.SET_PEC_PARAMETERS}</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormPecParameters
          coraSubjectSid={coraSubjectSid}
          archived={archived}
          onSave={(subjectSid) => save(subjectSid)}
          onCancel={onClose}
        />
      </Modal.Body>
    </Modal>
  )
}
